import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  am: {
    translation: {
      all_works: "դիտել բոլորը",
      home: "Գլխավոր",
      about: "Մեր մասին",
      team: "Մեր թիմը",
      jobs: "Թափուր հաստիքներ",
      certificates: "Մրցանակներ և սերտիֆիկատներ",
      videos: "տեսանյութեր",
      services: "Ծառայություններ",
      portfolio: "Աշխատանքներ",
      branches: "Մասնաճյուղեր",
      contact: "Հետադարձ կապ",
      herotext: "Բացահայտեք արեվային էներգիայի հնարավորությունները",
      wellcometitle: "Ձեր արեվային ապագան",
      wellcometitle2: "Բարի գալուստ Սոլար Հոլդինգ ՍՊԸ",
      wellcomelist: [
        "Սոլար Հոլդինգն արևային էներգետիկ կազմակերպություն է, որը զբաղվում է արևային կայանների և ջրատաքացուցիչների ներմուծմամբ, վաճառքով և տեղադրմամբ։",
        "Ընկերությունն իր ակտիվ գործունեությունը սկսել է 2020 թ․, մարտի 17-ից։ Շեշտը դրված է որակի վրա, որը կփաստեն մեր հաճախորդները։",
        "Տեղադրվող արևային վահանակներն արտադրված են ոլորտի առաջատար Q-Sun և Longi ընկերությունների կողմից, որոնք աչքի են ընկնում իրենց բարձր որակով և արդյունավետությամբ։ Համակարգերը համալրվում են Solis և Deye ապրանքանիշերի բարձր և հուսալի փոխակերպիչներով",
        "Սոլար Հոլդինգն հանդիսանում է Q-Sun սոլար վահանակների պաշտոնական ներկայացուցիչը Կովկասյան տարածաշրջանում։",
        "Դեկտեմբերի 1-ից հունվարի 30-ը ընկած ժամանակահատվածում արևային կայան գնած հաճախորդները մասնակցեցին BYD E2 էլեկտրոմոբիլի խաղարկությանը։ Հաղթող ճանաչվեց Գոհար Իսաջանյանը՝ ք․ Արարատից։",
      ],
      wellcomrbtn: " Ավելի շատ ինֆորմացիա",
      Dissatisfiedcustomers: "Դժգոհ հաճախորդներ",
      Employees: "Աշխատակիցներ",
      Satisfiedcustomers: "Գոհ հաճախորդներ",
      Services: "Ծառայություններ",
      Trialoftheyear: " Տարվա փորձ",
      click_on_service:
        "Սեղմեք ցանկացած քարտի վրա՝ մանրամասները տեսնելու համար",
      click_on_card:
        "Սեղմեք վերևի ցանկացած քարտի վրա՝ մանրամասները տեսնելու համար",
      Whysolarenergy: "Ինչու՞\n արեվային էներգետիկա",
      whyinfo: ` Արևային էներգիան աշխարհում գոյություն ունեցող էներգետիկ աղբյուրներից
        ամենամեծն և անսպառն է: Արևի էներգիան հնարավոր է փոխակերպել ինչպես
        էլեկտրական այնպես էլ ջերմային էներգիաների: Արևային էներգիան ջերմայինի
        փոխակերպելու արդյունավետությունը կազմում է շուրջ 70%, իսկ էլեկտրական
        էներգիայի դեպքում շուրջ 22%-ի: Արևային էներգիայի օգտագործումը ունի մի
        շարք առավելություններ, որոնք հատկապես գրավիչ են դարձնում ոլորտը թե՛
        ներդրումային , թե՛ սոցիալական տեսանկյունից։ Այսպիսով, յուրաքանչյուր տիպի
        սպառողի համար արևային էներգիայի անցումը կարող է դառնալ խնայողության և
        կայուն զարգացման լավագույն տարբերակ։`,
      whylist: [
        "Էներգիայի անսահամանափակ, վերականգնվող և մաքուր աղբյուր",
        "Անկախություն գազի և էլեկտրէներգիայի թանկացումներից՝ երկարաժամկետում",
        "Բնապահպանական մեծաթիվ օգուտներ․ այդ թվում CO2 գազի արտանետումների կրճատում, անապատացած հողերի օգտագործում,գլոբալ տաքացման դեմ պայքար",
        "Կայուն, նվազագույն ռիսկերով և երկարաժամկետում առավելագույն խնայողությամբ ներդրումների հնարավորություն։",
        "Սոցիալական օգուտներ, այդ թվում կենսապայմանների բարելավում ՝ կենցաղային խնդիրների լուծման և խնայողությունների միջոցով։",
      ],
      Thesun: "Արեվը՝ ձեր էներգիայի աղբյուրը",
      convert: "Փոխակերպեք արևի լույսը հզոր և կայուն էներգիայի։",
      Whychoose: "Ինչու՞ ընտրել մեզ",
      Weoffer: "Մենք առաջարկում ենք լավագույն արևային լուծումները։",
      service1title: "Անվճար չափագրում",
      service1desc: `Մենք կատարում ենք անվճար չափագրում՝ ապահովելով ճիշտ և արդյունավետ արևային համակարգի տեղադրում`,
      service2title: "Անվճար խորհրդատվություն",
      service2desc:
        "Մեր մասնագետները կօգնեն ընտրել լավագույն լուծումը՝ հաշվի առնելով ձեր կարիքներն ու բյուջեն։",
      service3title: "Անվճար տեղադրում",
      service3desc:
        "Մենք ապահովում ենք արագ և որակյալ տեղադրում՝ երաշխավորելով երկարաժամկետ աշխատանք։",
      options_data: [
        {
          title: "Բարձր որակ",
          desc: "Մենք օգտագործում ենք միայն բարձրորակ նյութեր՝ ապահովելով երկարաժամկետ և հուսալի արդյունք։",
        },
        {
          title: "Անհատական մոտեցում",
          desc: "Յուրաքանչյուր նախագիծ մշակվում է՝ հաշվի առնելով ձեր պահանջներն ու բյուջեն։",
        },
        {
          title: "Սեղմ ժամկետներ",
          desc: "Աշխատանքները կատարվում են արագ և հստակ ժամկետներում՝ առանց որակի կորստի։",
        },
        {
          title: "Պրոֆեսիոնալ թիմ",
          desc: "Մեր փորձառու մասնագետները ապահովում են բարձրակարգ սպասարկում յուրաքանչյուր փուլում։",
        },
        {
          title: "Երկարամյա փորձ",
          desc: "Տարիների փորձը թույլ է տալիս առաջարկել վստահելի և արդյունավետ լուծումներ։",
        },
        {
          title: "Մատչելի գներ",
          desc: "Առաջարկում ենք մրցունակ գներ՝ լավագույն արժեք/որակ հարաբերակցությամբ։",
        },
        {
          title: "Բարձրորակ նյութեր",
          desc: "Օգտագործում ենք միայն ստուգված և սերտիֆիկացված նյութեր։",
        },
        {
          title: "Տեխնիկական սպասարկում",
          desc: "Ապահովում ենք շարունակական տեխնիկական սպասարկում և աջակցություն։",
        },
      ],
      works_title: "Մեր աշխատանքները",
      works_subtitle: "Ընտրեք ձեր նախագիծը",
      complexes_data: [
        {
          number: 1,
          name: "Դրվածքային հզորություն 198.4 ԿՎՏ",
          info: `Ա-ՏԵԳ ՍՊԸ Դիլիջան թբիլիսյան խճուղի 17, տեղադրվել է Q-SUN 720W հզորության 275 վահանակ, տարեկան արտադրողություն 277.760 ԿՎՏ/Ժ, տարեկան խնայողություն 13.888.000 դր, տեղադրվել է SOLIS փոխակերպիչ 80 և 100 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 2,
          name: "Դրվածքային հզորություն 49.99 ԿՎՏ",
          info: `Հովտաշատ 12փ / 53 Արթուր Կիրակոսյան տեղադրվել է SAIL SOLAR 648W հզորության 78 վահանակ, տարեկան արտադրողականություն 69.888 ԿՎՏ/Ժ, տարեկան խնայողություն 3.494.400 դր տեղադրվել է SOLIS փոխակերպիչ 50 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 3,
          name: "Դրվածքային հզորություն 149.76 ԿՎՏ",
          info: `Հովտաշատ Բաղրամյան փ 3 / 81 Բախտիկո ՍՊԸ տեղադրվել է LONGI 648W հզորության 234 վահանակ, տարեկան արտադրողականություն 209.664 ԿՎՏ/Ժ, տարեկան խնայողություն 10.483.200 դր տեղադրվել է SOLIS փոխակերպիչ 50 և 100 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 4,
          name: "Դրվածքային հզորություն 34.16 ԿՎՏ",
          info: `Երևան Տիգրան Մեծ պող․ 40 / 4 Հակոբ Սաֆարյան տեղադրվել է SAIL SOLAR 610W հզորության 56 վահանակ, տարեկան արտադրողականություն 47.824 ԿՎՏ/Ժ, տարեկան խնայողություն 2.391.200 դր տեղադրվել է SOLIS փոխակերպիչ 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 5,
          name: "Դրվածքային հզորություն 50.22 ԿՎՏ",
          info: `Տավուշի մ․ Իջևան Հ․Մեհրաբյան փ․ 102 / 5 տեղադրվել է Q-SUN 620W հզորության 81 վահանակ, տարեկան արտադրողականություն 60.264 ԿՎՏ/Ժ, տարեկան խնայողություն 3.013.200 դր տեղադրվել է SOLIS փոխակերպիչ 100 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 6,
          name: "JIADELE Ջրատաքացուցիչ",
          info: `Հրազդան 6 / 1 փ․ 1 տեղադրվել JIADELE Ջրատաքացուցիչ, 8 հատ 400լ տարողությամբ։`,
        },
        {
          number: 7,
          name: "Դրվածքային հզորություն 130.2 ԿՎՏ",
          info: `Մարմարաշեն Երևան-Արտաշատ խճղ․ 4 / 1 Ալեքս 99 ՍՊԸ, տեղադրվել է Q-SUN 620W հզորության 210 վահանակ, տարեկան արտադրողականություն 195.300 ԿՎՏ/Ժ, տարեկան խնայողություն 9.765.000 դր տեղադրվել է SOLIS փոխակերպիչ 100 և 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 8,
          name: "JIADELE Ջրատաքացուցիչ",
          info: `Դավթաշեն Եղվարդի խճղ․ 126 Էս Վե Հյուրանոց ՍՊԸ, JIADELE Ջրատաքացուցիչ, 10 հատ 400լ տարողությամբ։`,
        },
        {
          number: 9,
          name: "Դրվածքային հզորություն 65.1 ԿՎՏ",
          info: `Դիլիջան, Թբիլիսյան խճղ․ 14 ՎՎ Գազ ՍՊԸ, տեղադրվել է Q-SUN 620W հզորության 105 վահանակ, տարեկան արտադրողականություն 768.120 ԿՎՏ/Ժ, տարեկան խնայողություն 3.906.000 դր տեղադրվել է SOLIS փոխակերպիչ 60 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 10,
          name: "Դրվածքային հզորություն 29.76 ԿՎՏ",
          info: `Դարակերտ Հաըդուկների փ․ 22 / 1 Հայկ Խաչատրյան տեղադրվել է Q-SUN 620W հզորության 48 վահանակ, տարեկան արտադրողականություն 744.640 ԿՎՏ/Ժ, տարեկան խնայողություն 2.232.000 դր տեղադրվել է SOLIS փոխակերպիչ 30 ԿՎՏ հզորությամբ։ `,
        },
        {
          number: 11,
          name: "Դրվածքային հզորություն 34.72 ԿՎՏ",
          info: ` Արարատի մարզ գ․ Շահումյան Սարգսյան փ․ 21 Անդրանիկ Սիմոնյան տեղադրվել է Q-SUN 620W հզորության 56 վահանակ, տարեկան արտադրողականություն 52.080 ԿՎՏ/Ժ, տարեկան խնայողություն 2.604.000 դր տեղադրվել է SOLIS փոխակերպիչ 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 12,
          name: "Դրվածքային հզորություն 35.96 ԿՎՏ",
          info: ` Արմավիր Ալաշկերտ 27 փ․ 5 Կոլյա Հովհաննիսյան Միհրանի ԱՁ տեղադրվել է Q-SUN 620W հզորության 58 վահանակ, տարեկան արտադրողականություն 53.940 ԿՎՏ/Ժ, տարեկան խնայողություն 2.697.000 դր տեղադրվել է SOLIS փոխակերպիչ 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 13,
          name: "Դրվածքային հզորություն 29․76 ԿՎՏ",
          info: `Ք․ Արմավիր գ․ Մրգաշատ 2փ 1շ տեղադրվել է Q-SUN 620W հզորության 48 վահանակ, տարեկան արտադրողականություն 44.620 ԿՎՏ/Ժ, տարեկան խնայողություն 2.232.000 դր տեղադրվել է SOLIS փոխակերպիչ 40 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 14,
          name: "Դրվածքային հզորություն 29․76 ԿՎՏ",
          info: `Էջմիածին Ոսկեհատի խճուղի Սարգիս Սահակյան տեղադրվել է Q-SUN 620W հզորության 65 վահանակ, տարեկան արտադրողականություն 60.450 ԿՎՏ/Ժ, տարեկան խնայողություն 3.022.500 դր տեղադրվել է SOLIS փոխակերպիչ 40 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 15,
          name: "Դրվածքային հզորություն 53․32 ԿՎՏ",
          info: `Երևան, Շենգավիթ, Արտաշատի խճղ․ 1 / 22 Մաքրություն ՍՊԸ տեղադրվել է Q-SUN 620W հզորության 86 վահանակ, տարեկան արտադրողականություն 79.980 ԿՎՏ/Ժ, տարեկան խնայողություն 3.999.000 դր տեղադրվել է SOLIS փոխակերպիչ 50 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 16,
          name: "Դրվածքային հզորություն 161․92 ԿՎՏ",
          name: "Դրվածքային հզորություն 34․72 ԿՎՏ",
          info: `Երևան Մալաոիա Սեբաստիա, Բաշինջաղյան 175/ 7 Էտալոն Սուպերմարկետ տեղադրվել է LONGI 640W հզորության 253 վահանակ, տարեկան արտադրողականություն 210.496 ԿՎՏ/Ժ, տարեկան խնայողություն 12.144.000 դր տեղադրվել է SOLIS փոխակերպիչ 100 և 50 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 17,
          name: "Դրվածքային հզորություն 34․72 ԿՎՏ",
          info: `Տավուշ Բրենդ Մաշտոցի 1358 Համլետ Փալանդուզյան տեղադրվել է Q-SUN 640W հզորության 56 վահանակ, տարեկան արտադրողականություն 41.664 ԿՎՏ/Ժ, տարեկան խնայողություն 2.083.200 դր տեղադրվել է SOLIS փոխակերպիչ 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 18,
          name: "Դրվածքային հզորություն 90 ԿՎՏ",
          info: `ք․Գորիս Առաքելյան փ․ 30 Էր Ընդ Սռեգ ՍՊԸ տեղադրվել է Q-SUN 620W հզորության 129 վահանակ, տարեկան արտադրողականություն 103.974 ԿՎՏ/Ժ, տարեկան խնայողություն 5.198.700 դր տեղադրվել է FosxFess փոխակերպիչ 75 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 19,
          name: "Դրվածքային հզորություն 70․4 ԿՎՏ",
          info: `ք․Երևան Շիրակի փ․ 90 / 1 ԳոռՀակ Թրեյդ տեղադրվել է Q-SUN 620W հզորության 129 վահանակ, տարեկան արտադրողականություն 105.600 ԿՎՏ/Ժ, տարեկան խնայողություն 5.250.000 դր տեղադրվել է SOLIS փոխակերպիչ 50 և 20 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 20,
          name: "Դրվածքային հզորություն 60.27 ԿՎՏ",
          info: `Կոտայքի մարզ գ․ Բալահովիտ փ․8 15շ․ Միգ տեխսպասարկում ՍՊԸ տեղադրվել է LONGI 615W հզորության 98 վահանակ, տարեկան արտադրողականություն 90.405 ԿՎՏ/Ժ, տարեկան խնայողություն 4.520.250 դր տեղադրվել է SOLIS փոխակերպիչ 60 и 20 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 21,
          name: "Դրվածքային հզորություն 90.82 ԿՎՏ",
          info: `Վայոց Ձորի մարզ Արփա Պառնաս համալիր Նորավանք Մայիս Մկրտչյան տեղադրվել է Q-SUN 620W հզորության 161 վահանակ, տարեկան արտադրողականություն 149.730 ԿՎՏ/Ժ, տարեկան խնայողություն 7.486.500 դր տեղադրվել է Foxess փոխակերպիչ 60 и 40 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 22,
          name: "Դրվածքային հզորություն 9.92 ԿՎՏ",
          info: `Վայոց Ձորի մարզ ք․Վայք Սուրբ Տրդատ եկեղեցի տեղադրվել է Q-SUN 620W հզորության 16 վահանակ, տարեկան արտադրողականություն 15.000 ԿՎՏ/Ժ, տարեկան խնայողություն 750.000 դր տեղադրվել է SOLIS փոխակերպիչ 10 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 23,
          name: "Դրվածքային հզորություն 70.06 ԿՎՏ",
          info: `Ք․ Արտաշատ Երևան - Երասխ մայրուղու 28 կմ Ոսկե Հասկ ՍՊԸ տեղադրվել է Q-SUN 620W հզորության 113 վահանակ, տարեկան արտադրողականություն 105.090 ԿՎՏ/Ժ, տարեկան խնայողություն 5.254.500 դր տեղադրվել է Foxess փոխակերպիչ 75 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 24,
          name: "Դրվածքային հզորություն 49.6 ԿՎՏ",
          info: `Սյունիքի մարզ ք․Ագարակ ML Հյուրանոց տեղադրվել է Q-SUN 620W հզորության 80 վահանակ, տարեկան արտադրողականություն 55.000 ԿՎՏ/Ժ, տարեկան խնայողություն 2․750.000 դր տեղադրվել է SOLIS փոխակերպիչ 15 և 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 25,
          name: "Դրվածքային հզորություն 70.11 ԿՎՏ",
          info: `Ք․ Երևան Քանաքեռ Զեյթուն Ահարոնյան 12 տեղադրվել է LONGI 620W հզորության 114 վահանակ, տարեկան արտադրողականություն 105.165 ԿՎՏ/Ժ, տարեկան խնայողություն 5․258.250 դր տեղադրվել է Foxess փոխակերպիչ 75 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 26,
          name: "Դրվածքային հզորություն 79.98 ԿՎՏ",
          info: `Արարատի մարզ գ․ Ավշար ԳԱՎ ՍՊԸ տեղադրվել է LONGI 620W հզորության 129 վահանակ, տարեկան արտադրողականություն 119.970 ԿՎՏ/Ժ, տարեկան խնայողություն 5․998.500 դր տեղադրվել է Fox փոխակերպիչ 75 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 27,
          name: "Դրվածքային հզորություն 150․04 ԿՎՏ",
          info: `Լոռու մարզ գ․Մեծավան Բոզոյան ՍՊԸ տեղադրվել է LONGI 620W հզորության 242 վահանակ, տարեկան արտադրողականություն 195.052 ԿՎՏ/Ժ, տարեկան խնայողություն 9․752.600 դր տեղադրվել է Huawei փոխակերպիչ 50 և 100 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 28,
          name: "Դրվածքային հզորություն 29․70 (30) ԿՎՏ",
          info: `Ք․ Արարատ Գրիբայեդով փ․ 29 / 1 տեղադրվել է Q-SUN 620W հզորության 48 վահանակ, տարեկան արտադրողականություն 44.640 ԿՎՏ/Ժ, տարեկան խնայողություն 2․232.000 դր տեղադրվել է SOLIS փոխակերպիչ 30 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 29,
          name: "Դրվածքային հզորություն 150․06 ԿՎՏ",
          info: `Արմավիրի մարզ գ․ Եղեգնուտ տեղադրվել է LONGI 615W հզորության 243 վահանակ, տարեկան արտադրողականություն 225.090 ԿՎՏ/Ժ, տարեկան խնայողություն 11․254.500 դր տեղադրվել է Huawei փոխակերպիչ 50 и 100 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 30,
          name: "Դրվածքային հզորություն 171 ԿՎՏ",

          info: `ԳԱՎ ԲԱԶ ՍՊԸ տեղադրվել է LONGI 550W հզորության 300 վահանակ, տարեկան արտադրողականություն 274.000 ԿՎՏ/Ժ, տարեկան խնայողություն 14․552.000 դր  տեղադրվել է Huawei փոխակերպիչ 100 и 60 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 31,
          name: "Դրվածքային հզորություն 125 ԿՎՏ",
          info: `Վահագնի Հարսանյաց սրահ տեղադրվել է JINKO 550W հզորության 227 վահանակ, տարեկան արտադրողականություն 187.500 ԿՎՏ/Ժ, տեղադրվել է Huawei փոխակերպիչ 30 и 100 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 32,
          name: "Դրվածքային հզորություն 79․8 ԿՎՏ",
          info: `Գ․Արալեզ Արմեն Մանուկյան ԱՁ Քարի արտադրամաս տեղադրվել է LONGI 555W հզորության 109 վահանակ, տարեկան արտադրողականություն 90.000 ԿՎՏ/Ժ, տարեկան խնայողություն 14․522.000 դր տեղադրվել է SUNWAYS փոխակերպիչ 3 հատ 20 ԿՎՏ հզորությամբ։`,
        },
        {
          number: 33,
          name: "Դրվածքային հզորություն 79․8 ԿՎՏ",
          info: `ԳԱՎ ԲԱԶ ՍՊԸ տեղադրվել է LONGI 52․8 ԿՎՏ Risen 27 ԿՎՏ, տարեկան արտադրողականություն 119.700 ԿՎՏ/Ժ, տարեկան խնայողություն 5․985.000 դր տեղադրվել է FOX փոխակերպիչ 3 hat 25 ԿՎՏ հզորությամբ։`,
        },
      ],
      partners_title: "Մեր գործընկերները",
      footer_contacts: "Մեր կոնտակտները",
      footer_address: "Հայաստան, Երևան, Թաիրովի փող., 46 տուն",
      footer_map: "Կայքի քարտեզ",
      footer_rights: "Բոլոր իրավունքները պաշտպանված են",
      footer_team: "Մեր անձնակազմը",
      footer_jobs: "Թափուր հաստիքներ",
      footer_certs: "Մրցանակներ և սերտիֆիկատներ",
      footer_videos: "Տեսանյութեր",
      team_title: "Մեր Թիմը",
      team_subtitle: "ծանոթացեք մեր թիմին",
      team_members: [
        { name: "Իգոր Ավակյան", work: "Հիմնադիր" },
        { name: "Գեվորգ Արշակյան", work: "Գործադիր տնօրեն" },
        { name: "Սուրեն Ավագյան", work: "Տեխնիկական տնօրեն" },
        { name: "Նարեկ Հովհաննիսյան", work: "Փոխտնօրեն" },
        { name: "Լեվոն Գաբրիելյան", work: "Վաճառքի տնօրեն" },
        { name: "Դավիթ Թովմասյան", work: "Արմավիր մասնաճյուղի տնօրեն" },
        { name: "Գարուշ Ստեփանյան", work: "Գ․Արարատ մասնաճյուղի տնօրեն" },
        { name: "Սեդա Սեդրակյան", work: "Վաճառքի ֆինանսավորման բաժնի ղեկավար" },
        { name: "Հասմիկ Ղադյան", work: "Պայմանագրային բաժնի ղեկավար" },
        { name: "Նինել Խաչատուրյան", work: "Զանգերի կենտրոնի ղեկավար" },
        { name: "Սոֆիա Ֆահրադյան", work: "Հաշվապահ" },
        { name: "Կարեն Ղազարյան", work: "Էներգետիկ" },
        { name: "Թելման Հովհաննիսյան", work: "Պահեստապետ" },
        { name: "Կարեն Եղիազարյան", work: "Որակի վերահսկման բաժնի պետ" },
        {
          name: "Արգեն Թումանյան",
          work: "Վաճառքի ֆինանսավորման բաժնի մասնագետ",
        },
        { name: "Հովհաննես Գեվորգյան", work: "Մենեջեր" },
        { name: "Թամարա Հովսեփյան", work: "Զանգերի կենտրոնի մասնագետ" },
      ],
      ongrid_title: "☀️ Ongrid (ցանցային) արևային համակարգեր",
      ongrid_description:
        "Ongrid համակարգերը միացված են էլեկտրական ցանցին և աշխատում են համատեղ։ Արտադրված էներգիան նախ օգտագործվում է ձեր կարիքների համար, իսկ ավելցուկը փոխանցվում է ընդհանուր ցանց։",
      ongrid_advantages: "Առավելություններ",
      ongrid_adv1: "Ցածր ներդրում (մարտկոցներ չեն պահանջվում)",
      ongrid_adv2: "Բարձր արդյունավետություն",
      ongrid_adv3: "Էլեկտրաէներգիայի ծախսերի զգալի կրճատում",
      ongrid_disadvantages: "Թերություններ",
      ongrid_disadv1: "Հոսանքի անջատման դեպքում համակարգը չի աշխատում",
      ongrid_suitable: "Հարմար է",
      ongrid_suitable_text:
        "Բնակարանների, առանձնատների և բիզնեսների համար, որտեղ կա կայուն էլեկտրացանց",
      ongrid_key_feature: "Խնայեք առանց մեծ նախնական ներդրումների",

      offgrid_title: "🔋 Offgrid (անկախ) արևային համակարգեր",
      offgrid_description:
        "Offgrid համակարգերը ամբողջությամբ անկախ են էլեկտրական ցանցից և աշխատում են մարտկոցների միջոցով՝ կուտակելով արևային էներգիան։",
      offgrid_advantages: "Առավելություններ",
      offgrid_adv1: "Լիարժեք էներգետիկ անկախություն",
      offgrid_adv2: "Աշխատում է նաև հոսանքի բացակայության դեպքում",
      offgrid_disadvantages: "Թերություններ",
      offgrid_disadv1: "Ավելի բարձր արժեք (մարտկոցների պատճառով)",
      offgrid_disadv2: "Մարտկոցների պարբերական սպասարկման անհրաժեշտություն",
      offgrid_suitable: "Հարմար է",
      offgrid_suitable_text:
        "Հեռավոր տարածքների, ամառանոցների և այն վայրերի համար, որտեղ չկա էլեկտրական ցանց",
      offgrid_key_feature: "Եղեք լիովին անկախ էլեկտրացանցից",

      hybrid_title: "⚡ Hybrid (հիբրիդ) արևային համակարգեր",
      hybrid_description:
        "Hybrid համակարգերը համատեղում են ongrid և offgrid լուծումները՝ աշխատելով թե՛ ցանցի, թե՛ մարտկոցների հետ։",
      hybrid_advantages: "Առավելություններ",
      hybrid_adv1: "Աշխատում է հոսանքի անջատման ժամանակ",
      hybrid_adv2:
        "Թույլ է տալիս խնայել և միաժամանակ ունենալ պահուստային էներգիա",
      hybrid_adv3: "Ճկուն և խելացի կառավարում",
      hybrid_disadvantages: "Թերություններ",
      hybrid_disadv1: "Ավելի բարձր գին՝ ongrid-ի համեմատ",
      hybrid_suitable: "Հարմար է",
      hybrid_suitable_text:
        "Տների և բիզնեսների համար, որոնք ցանկանում են և՛ խնայել, և՛ ապահովել անխափան հոսանք",
      hybrid_key_feature: "Համատեղեք խնայողությունն ու անխափան սնուցումը",
      exhibition_title: "Միջազգային Կանտոնի ցուցահանդես 2025",
      exhibition_text_1:
        "2025 թվականի հոկտեմբերի 15-ին Solar Holding ընկերությունն, ի դեմս ընկերության հիմնադիր Իգոր Ավակյանի, իր մասնակցությունն ունեցավ Չինաստանի Գուանչժոու քաղաքում անցկացվող միջազգային Կանտոնի ցուցահանդեսին (China Import and Export Fair)։",
      exhibition_text_2:
        "Մասնակցությունը հնարավորություն տվեց ներկայացնելու մեր արևային էներգետիկ լուծումները, ուսումնասիրելու միջազգային շուկայի միտումները և հաստատելու նոր համագործակցություններ՝ ուղղված կայուն էներգետիկ զարգացմանն ու նորարարությանը։",
      exhibition_text_3:
        "Ցուցահանդեսի շրջանակում կայացան մի շարք կարևոր հանդիպումներ։ Մասնավորապես՝ Սոլիսի ներկայացուցիչների հետ քննարկումներն անցան կառուցողական մթնոլորտում։ Ներկայացրեցինք մեր առաջարկներն ու համագործակցության խորացման տարբերակները։",
      exhibition_text_4:
        "Առանձնացվեցին մի շարք ընդհանուր հետաքրքրություն ներկայացնող հարցեր, որոնց մասին ավելի մանրամասն կանդրադառնանք առաջիկայում։",
      solar_systems_title: "Արևային համակարգեր",
      solar_systems_subtitle: "Ընտրեք ձեզ համար հարմար լուծումը",
      branches_page_title: "Մասնաճյուղեր",
      branches_page_subtitle: "Ընտրեք մասնաճյուղը և տեսեք ամբողջական տվյալները",
      branches_address_label: "Հասցե",
      branches_open_map: "Բացել քարտեզը",
      branches_select_prompt:
        "Սեղմեք որևէ մասնաճյուղի քարտի վրա՝ մանրամասները տեսնելու համար։",
      branches_list: [
        {
          name: "Գլխամաս",
          address: "ք. Երևան, Թաիրով փողոց, 46",
          mapUrl:
            "https://yandex.ru/navi/org/solar_holding/121702865151?si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "ք․ Արարատ մասնաճյուղ",
          address: "ք․ Արարատ, Աղբյուր Սերոբի փողոց, 12/1",
          mapUrl:
            "https://yandex.ru/navi/org/solar_holding/208880807718?si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Զանգերի կենտրոն",
          address: "ք․ Արարատ, Աբովյան փողոց, 11/50",
          mapUrl:
            "https://yandex.ru/navi?whatshere%5Bzoom%5D=20&whatshere%5Bpoint%5D=44.695868,39.857169&si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "գ․ Արարատ մասնաճյուղ",
          address: "գ․ Արարատ, Գրիբոյեդովի փողոց, 8",
          mapUrl:
            "https://yandex.ru/navi?whatshere%5Bzoom%5D=19&whatshere%5Bpoint%5D=44.705706,39.836641&si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Էջմիածին մասնաճյուղ",
          address: "ք․ Էջմիածին, Պատկանյան փողոց, 21/5",
          mapUrl: "https://yandex.ru/maps/-/CPvUrElm",
        },
        {
          name: "Արմավիր մասնաճյուղ",
          address: "ք․ Արմավիր, Երևանյան 15/4",
          mapUrl:
            "https://yandex.ru/navi?text=40.143922,44.038862&si=t40ungzmvnuzbwjxezh11d40hr",
        },
      ],
      no_project_selected: "Նախագիծ ընտրված չէ",
      back: "Վերադառնալ",
      services_page_title: "Մեր Ծառայությունները",
      services_page_subtitle: "SOLAR HOLDING",
      services_page_intro:
        "Սոլար Հոլդինգը առաջարկում է արևային համակարգերի ամբողջական լուծումներ՝ սկսած ներմուծումից մինչև տեղադրում և սպասարկում։",
      services_advantages_title: "Ինչու ընտրել մեզ",
      services_advantages_list: [
        "Բարձր որակ",
        "Արագ տեղադրում",
        "Մասնագիտական թիմ",
        "Լավագույն գներ",
      ],
      services_cta_title: "Պատրա՞ստ եք անցնել արեվային էներգիայի",
      services_cta_button: "Կապ հաստատել",
      services_page_items: [
        {
          title: "Արեվային կայանների վաճառք",
          desc: "Մենք առաջարկում ենք բարձրորակ արևային կայաններ՝ տարբեր հզորություններով՝ ձեր տան կամ բիզնեսի համար։",
        },
        {
          title: "Արեվային համակարգերի տեղադրում",
          desc: "Մեր մասնագետները իրականացնում են արագ և որակյալ տեղադրում՝ ապահովելով համակարգի երկարատև աշխատանք։",
        },
        {
          title: "Ներմուծում և մատակարարում",
          desc: "Մենք ներմուծում ենք արևային համակարգերի բոլոր անհրաժեշտ բաղադրիչները՝ ապահովելով լավագույն գին և որակ։",
        },
        {
          title: "Կայանների տեղափոխություն",
          desc: "Իրականացնում ենք արևային կայանների պրոֆեսիոնալ տեղափոխություն ցանկացած հեռավորության վրա՝ ապահովելով սարքավորումների ամբողջական անվտանգությունը և արագ տեղադրումը նոր վայրում։",
        },
      ],
      contact_page_title: "Հետադարձ կապ",
      contact_page_subtitle: "Կապվեք մեզ հետ",
      contact_name_placeholder: "Անուն",
      contact_email_placeholder: "Էլ. հասցե",
      contact_message_placeholder: "Հաղորդագրություն",
      contact_send_button: "Ուղարկել",
      contact_send_loading: "Ուղարկվում է...",
      contact_send_error: "Սխալ ուղարկման ժամանակ. Փորձեք ավելի ուշ.",
      contact_fill_all_fields: "Խնդրում ենք լրացնել բոլոր դաշտերը.",
      contact_sent_alert: "Հաղորդագրությունը ուղարկված է ✅",
      certificates_page_title: "Լիցենզիա եվ սերտիֆիկատներ",
      certificates_page_subtitle: "պաշտոնական փաստաթղթեր",
      jobs_page_title: "Թափուր հաստիքներ",
      jobs_page_subtitle: "Միացիր մեր թիմին",
      jobs_apply_deadline: "Դիմելու վերջնաժամկետ՝",
      jobs_apply_button: "Դիմել",
      jobs_application_for: "Դիմում՝",
      jobs_send_loading: "Ուղարկվում է դիմումը...",
      jobs_send_error: "Սխալ ուղարկման ժամանակ. Փորձեք ավելի ուշ.",
      jobs_fill_all_fields: "Խնդրում ենք լրացնել բոլոր դաշտերը.",
      jobs_success_title: "Դիմումը ուղարկված է ✅",
      jobs_success_subtitle: "Շնորհակալություն հետաքրքրության համար",
      jobs_name_placeholder: "Անուն",
      jobs_email_placeholder: "Էլ. հասցե",
      jobs_message_placeholder: "Հաղորդագրություն / փորձ",
      jobs_submit_button: "Ուղարկել դիմում",
      jobs_list: ["Զանգերի կենտրոնի մասնագետ", "Վաճառքի մենեջեր"],
      videos_page_title: "Տեսանյութեր",
      videos_page_subtitle: "Մեր նախագծերը վիդեո ձեվաչափով",
      video_error_loading: "Տեսանյութի բեռնումը ձախողվեց",
      loading_player: "Նվագարկիչը բեռնվում է...",
    },
  },
  ru: {
    translation: {
      all_works: "посмотреть все",
      home: "Главная",
      about: "О нас",
      team: "Наша команда",
      jobs: "Вакансии",
      certificates: "Награды и сертификаты",
      videos: "Видео",
      services: "Услуги",
      portfolio: "Портфолио",
      branches: "Филиалы",
      contact: "Контакты",
      herotext: "Откройте новые возможности солнечной энергетики",
      wellcometitle: "Ваше солнечное будущее",
      wellcometitle2: "Добро пожаловать в Solar Holding LLC",
      wellcomelist: [
        "Solar Holding - это организация, занимающаяся солнечной энергетикой, которая занимается импортом, продажей и установкой солнечных станций и водонагревателей.",
        "Компания начала свою активную деятельность 17 марта 2020 года. Акцент делается на качество, что подтверждают наши клиенты.",
        "Устанавливаемые солнечные панели произведены ведущими в отрасли компаниями Q-Sun и Longi, которые отличаются своим высоким качеством и эффективностью. Системы оснащаются высококлассными и надежными инверторами брендов Solis и Deye",
        "Solar Holding является официальным представителем солнечных панелей Q-Sun в Кавказском регионе.",
        "В период с 1 декабря по 30 января клиенты, купившие солнечные станции, участвовали в розыгрыше электромобиля BYD E2. Победителем стала Гохар Исаджанян из города Арарат.",
      ],
      wellcomrbtn: "Дополнительная информация",
      Dissatisfiedcustomers: "Недовольные клиенты",
      Employees: "Сотрудники",
      Satisfiedcustomers: "Довольные клиенты",
      Services: "Услуги",
      Trialoftheyear: "лет испытаний",
      Whysolarenergy: "Почему\n солнечная энергия?",
      click_on_service: "Нажмите на любую карточку, чтобы увидеть детали",
      click_on_card: "Нажмите на любую карточку выше, чтобы увидеть детали",
      whyinfo: ` 
Солнечная энергия — крупнейший и наиболее распространенный источник энергии в мире. 
Солнечная энергия может быть преобразована как в электрическую, так и в тепловую энергию. 
Эффективность преобразования солнечной энергии в тепловую составляет около 70%,
 а в электрическую — около 22%. Использование солнечной энергии имеет ряд преимуществ, 
 которые делают этот сектор особенно привлекательным как с инвестиционной, так и с социальной точки зрения.
 Таким образом, для любого типа потребителей переход на солнечную энергию может 
 стать лучшим вариантом для экономии и устойчивого развития.`,
      whylist: [
        "Неограниченный, возобновляемый и чистый источник энергии",
        "Независимость от роста цен на газ и электроэнергию в долгосрочной перспективе",
        "Значительные экологические преимущества, включая сокращение выбросов CO2, использование деградированных земель и борьбу с глобальным потеплением",
        "Стабильная инвестиционная возможность с минимальными рисками и максимальной долгосрочной экономией",
        "Социальные преимущества, включая улучшение условий жизни за счёт решения бытовых проблем и экономии средств",
      ],
      Thesun: "Солнце — ваш источник энергии.",
      convert:
        "Преобразуйте солнечный свет в мощную и экологически чистую энергию.",
      Whychoose: "Почему выбирают нас?",
      Weoffer: "Мы предлагаем лучшие решения в области солнечной энергетики.",
      service1title: "Бесплатный замер",
      service1desc:
        "Мы выполняем бесплатный замер, обеспечивая точную и эффективную установку солнечной системы.",
      service2title: "Бесплатная консультация",
      service2desc:
        "Наши специалисты помогут выбрать оптимальное решение с учётом ваших потребностей и бюджета.",
      service3title: "Бесплатная установка",
      service3desc:
        "Мы обеспечиваем быструю и качественную установку с гарантией долгосрочной работы.",
      options_data: [
        {
          title: "Высокое качество",
          desc: "Мы используем только высококачественные материалы, обеспечивая долговечный и надежный результат.",
        },
        {
          title: "Индивидуальный подход",
          desc: "Каждый проект разрабатывается с учетом ваших требований и бюджета.",
        },
        {
          title: "Сжатые сроки",
          desc: "Работы выполняются быстро и в четкие сроки без потери качества.",
        },
        {
          title: "Профессиональная команда",
          desc: "Наши опытные специалисты обеспечивают первоклассный сервис на каждом этапе.",
        },
        {
          title: "Многолетний опыт",
          desc: "Годы опыта позволяют нам предлагать надежные и эффективные решения.",
        },
        {
          title: "Доступные цены",
          desc: "Мы предлагаем конкурентоспособные цены с лучшим соотношением цены и качества.",
        },
        {
          title: "Качественные материалы",
          desc: "Мы используем только проверенные и сертифицированные материалы.",
        },
        {
          title: "Техническое обслуживание",
          desc: "Мы обеспечиваем постоянное техническое обслуживание и поддержку.",
        },
      ],
      works_title: "Наши работы",
      works_subtitle: "Выберите ваш проект",
      complexes_data: [
        {
          number: 1,
          name: "Установленная мощность 198.4 кВт",
          info: `ООО А-ТЕГ, Дилижан, Тбилисское шоссе 17. Установлено 275 панелей Q-SUN мощностью 720 Вт. Годовая выработка: 277 760 кВт/ч, годовая экономия: 13 888 000 драмов. Установлены инверторы SOLIS мощностью 80 и 100 кВт.`,
        },
        {
          number: 2,
          name: "Установленная мощность 49.99 кВт",
          info: `Артур Киракосян, Овташат, 12-я ул. / 53. Установлено 78 панелей SAIL SOLAR мощностью 648 Вт. Годовая выработка: 69 888 кВт/ч, годовая экономия: 3 494 400 драмов. Установлен инвертор SOLIS мощностью 50 кВт.`,
        },
        {
          number: 3,
          name: "Установленная мощность 149.76 кВт",
          info: `ООО Бахтико, Овташат, ул. Баграмяна 3 / 81. Установлено 234 панели LONGI мощностью 648 Вт. Годовая выработка: 209 664 кВт/ч, годовая экономия: 10 483 200 драмов. Установлены инверторы SOLIS мощностью 50 и 100 кВт.`,
        },
        {
          number: 4,
          name: "Установленная мощность 34.16 кВт",
          info: `Акоп Сафарян, Ереван, пр. Тиграна Меца 40 / 4. Установлено 56 панелей SAIL SOLAR мощностью 610 Вт. Годовая выработка: 47 824 кВт/ч, годовая экономия: 2 391 200 драмов. Установлен инвертор SOLIS мощностью 30 кВт.`,
        },
        {
          number: 5,
          name: "Установленная мощность 50.22 кВт",
          info: `Тавушская обл., г. Иджеван, ул. О. Меграбяна 102 / 5. Установлено 81 панель Q-SUN мощностью 620 Вт. Годовая выработка: 60 264 кВт/ч, годовая экономия: 3 013 200 драмов. Установлен инвертор SOLIS мощностью 100 кВт.`,
        },
        {
          number: 6,
          name: "Водонагреватель JIADELE",
          info: `Раздан, 6 / 1, 1-я ул. Установлены водонагреватели JIADELE, 8 штук объемом по 400 л.`,
        },
        {
          number: 7,
          name: "Установленная мощность 130.2 кВт",
          info: `ООО Алекс 99, Мармарашен, трасса Ереван-Арташат 4 / 1. Установлено 210 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 195 300 кВт/ч, годовая экономия: 9 765 000 драмов. Установлены инверторы SOLIS мощностью 100 и 30 кВт.`,
        },
        {
          number: 8,
          name: "Водонагреватель JIADELE",
          info: `ООО Отель Эс Ве, Давташен, Егвардское шоссе 126. Водонагреватели JIADELE, 10 штук объемом по 400 л.`,
        },
        {
          number: 9,
          name: "Установленная мощность 65.1 кВт",
          info: `ООО ВВ Газ, Дилижан, Тбилисское шоссе 14. Установлено 105 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 768 120 кВт/ч, годовая экономия: 3 906 000 драмов. Установлен инвертор SOLIS мощностью 60 кВт.`,
        },
        {
          number: 10,
          name: "Установленная мощность 29.76 кВт",
          info: `Айк Хачатрян, Даракерт, ул. Гайдуков 22 / 1. Установлено 48 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 744 640 кВт/ч, годовая экономия: 2 232 000 драмов. Установлен инвертор SOLIS мощностью 30 кВт.`,
        },
        {
          number: 11,
          name: "Установленная мощность 34.72 кВт",
          info: `Андраник Симонян, Араратская обл., с. Шаумян, ул. Саргсяна 21. Установлено 56 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 52 080 кВт/ч, годовая экономия: 2 604 000 драмов. Установлен инвертор SOLIS мощностью 30 кВт.`,
        },
        {
          number: 12,
          name: "Установленная мощность 35.96 кВт",
          info: `ИП Коля Ованнисян Миграни, Армавир, ул. Алашкерт 27 / 5. Установлено 58 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 53 940 кВт/ч, годовая экономия: 2 697 000 драмов. Установлен инвертор SOLIS мощностью 30 кВт.`,
        },
        {
          number: 13,
          name: "Установленная мощность 29.76 кВт",
          info: `г. Армавир, с. Мргашат, 2-я ул., 1-е зд. Установлено 48 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 44 620 кВт/ч, годовая экономия: 2 232 000 драмов. Установлен инвертор SOLIS мощностью 40 кВт.`,
        },
        {
          number: 14,
          name: "Установленная мощность 29.76 кВт",
          info: `Саргис Саакян, Эчмиадзин, Воскехатское шоссе. Установлено 65 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 60 450 кВт/ч, годовая экономия: 3 022 500 драмов. Установлен инвертор SOLIS мощностью 40 кВт.`,
        },
        {
          number: 15,
          name: "Установленная мощность 53.32 кВт",
          info: `ООО Макрутюн, Ереван, Шенгавит, Арташатское шоссе 1 / 22. Установлено 86 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 79 980 кВт/ч, годовая экономия: 3 999 000 драмов. Установлен инвертор SOLIS мощностью 50 кВт.`,
        },
        {
          number: 16,
          name: "Установленная мощность 161.92 кВт",
          info: `Супермаркет Эталон, Ереван, Малатия-Себастия, ул. Башинджагяна 175/7. Установлено 253 панели LONGI мощностью 640 Вт. Годовая выработка: 210 496 кВт/ч, годовая экономия: 12 144 000 драмов. Установлены инверторы SOLIS мощностью 100 и 50 кВт.`,
        },
        {
          number: 17,
          name: "Установленная мощность 34.72 кВт",
          info: `Амлет Паландузян, Тавуш, ул. Маштоца 1358. Установлено 56 панелей Q-SUN мощностью 640 Вт. Годовая выработка: 41 664 кВт/ч, годовая экономия: 2 083 200 драмов. Установлен инвертор SOLIS мощностью 30 кВт.`,
        },
        {
          number: 18,
          name: "Установленная мощность 90 кВт",
          info: `ООО Эр Энд Срег, г. Горис, ул. Аракеляна 30. Установлено 129 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 103 974 кВт/ч, годовая экономия: 5 198 700 драмов. Установлен инвертор Foxess мощностью 75 кВт.`,
        },
        {
          number: 19,
          name: "Установленная мощность 70.4 кВт",
          info: `ГорХак Трейд, г. Ереван, ул. Ширака 90 / 1. Установлено 129 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 105 600 кВт/ч, годовая экономия: 5 250 000 драмов. Установлены инверторы SOLIS мощностью 50 и 20 кВт.`,
        },
        {
          number: 20,
          name: "Установленная мощность 60.27 кВт",
          info: `ООО Миг Техспасаркум, Котайкская обл., с. Балаховит, 8-я ул., 15-е зд. Установлено 98 панелей LONGI мощностью 615 Вт. Годовая выработка: 90 405 кВт/ч, годовая экономия: 4 520 250 драмов. Установлены инверторы SOLIS мощностью 60 и 20 кВт.`,
        },
        {
          number: 21,
          name: "Установленная мощность 90.82 кВт",
          info: `Майис Мкртчян, Вайоцдзорская обл., комплекс Арпа Парнас, Нораванк. Установлена 161 панель Q-SUN мощностью 620 Вт. Годовая выработка: 149 730 кВт/ч, годовая экономия: 7 486 500 драмов. Установлены инверторы Foxess мощностью 60 и 40 кВт.`,
        },
        {
          number: 22,
          name: "Установленная мощность 9.92 кВт",
          info: `Церковь Сурб Трдат, г. Вайк, Вайоцдзорская обл. Установлено 16 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 15 000 кВт/ч, годовая экономия: 750 000 драмов. Установлен инвертор SOLIS мощностью 10 кВт.`,
        },
        {
          number: 23,
          name: "Установленная мощность 70.06 кВт",
          info: `ООО Воске Аск, г. Арташат, 28-й км трассы Ереван-Ерасх. Установлено 113 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 105 090 кВт/ч, годовая экономия: 5 254 500 драмов. Установлен инвертор Foxess мощностью 75 кВт.`,
        },
        {
          number: 24,
          name: "Установленная мощность 49.6 кВт",
          info: `Отель ML, г. Агарак, Сюникская обл. Установлено 80 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 55 000 кВт/ч, годовая экономия: 2 750 000 драмов. Установлены инверторы SOLIS мощностью 15 и 30 кВт.`,
        },
        {
          number: 25,
          name: "Установленная мощность 70.11 кВт",
          info: `г. Ереван, Канакер-Зейтун, ул. Агароняна 12. Установлено 114 панелей LONGI мощностью 620 Вт. Годовая выработка: 105 165 кВт/ч, годовая экономия: 5 258 250 драмов. Установлен инвертор Foxess мощностью 75 кВт.`,
        },
        {
          number: 26,
          name: "Установленная мощность 79.98 кВт",
          info: `ООО ГАВ, Араратская обл., с. Авшар. Установлено 129 панелей LONGI мощностью 620 Вт. Годовая выработка: 119 970 кВт/ч, годовая экономия: 5 998 500 драмов. Установлен инвертор Fox мощностью 75 кВт.`,
        },
        {
          number: 27,
          name: "Установленная мощность 150.04 кВт",
          info: `ООО Бозоян, Лорийская обл., с. Мецаван. Установлено 242 панели LONGI мощностью 620 Вт. Годовая выработка: 195 052 кВт/ч, годовая экономия: 9 752 600 драмов. Установлены инверторы Huawei мощностью 50 и 100 кВт.`,
        },
        {
          number: 28,
          name: "Установленная мощность 29.70 (30) кВт",
          info: `г. Арарат, ул. Грибоедова 29 / 1. Установлено 48 панелей Q-SUN мощностью 620 Вт. Годовая выработка: 44 640 кВт/ч, годовая экономия: 2 232 000 драмов. Установлен инвертор SOLIS мощностью 30 кВт.`,
        },
        {
          number: 29,
          name: "Установленная мощность 150.06 кВт",
          info: `Армавирская обл., с. Ехегнут. Установлено 243 панели LONGI мощностью 615 Вт. Годовая выработка: 225 090 кВт/ч, годовая экономия: 11 254 500 драмов. Установлены инверторы Huawei мощностью 50 и 100 кВт.`,
        },
        {
          number: 30,
          name: "Установленная мощность 171 кВт",
          info: `ООО ГАВ БАЗ. Установлено 300 панелей LONGI мощностью 550 Вт. Годовая выработка: 274 000 кВт/ч, годовая экономия: 14 552 000 драмов. Установлены инверторы Huawei мощностью 100 и 60 кВт.`,
        },
        {
          number: 31,
          name: "Установленная мощность 125 кВт",
          info: `Свадебный салон Ваагни. Установлено 227 панелей JINKO мощностью 550 Вт. Годовая выработка: 187 500 кВт/ч. Установлены инверторы Huawei мощностью 30 и 100 кВт.`,
        },
        {
          number: 32,
          name: "Установленная мощность 79.8 кВт",
          info: `ИП Армен Манукян, с. Аралез, цех по обработке камня. Установлено 109 панелей LONGI мощностью 555 Вт. Годовая выработка: 90 000 кВт/ч, годовая экономия: 14 522 000 драмов. Установлены инверторы SUNWAYS: 3 шт. по 20 кВт.`,
        },
        {
          number: 33,
          name: "Установленная мощность 79.8 кВт",
          info: `ООО ГАВ БАЗ. Установлено: LONGI 52.8 кВт и Risen 27 кВт. Годовая выработка: 119 700 кВт/ч, годовая экономия: 5 985 000 драмов. Установлены инверторы FOX: 3 шт. по 25 кВт.`,
        },
      ],
      partners_title: "Наши партнеры",
      footer_contacts: "Наши контакты",
      footer_address: "Армения, Ереван, ул. Таирова, дом 46",
      footer_map: "Карта сайта",
      footer_rights: "Все права защищены",
      footer_team: "Наш персонал",
      footer_jobs: "Вакансии",
      footer_certs: "Награды и сертификаты",
      footer_videos: "Видеоматериалы",
      team_title: "Наша Команда",
      team_subtitle: "познакомьтесь с нашей командой",
      team_members: [
        { name: "Игор Авакян", work: "Основатель" },
        { name: "Геворг Аршакян", work: "Генеральный директор" },
        { name: "Сурен Авагян", work: "Технический директор" },
        { name: "Нарек Ованнисян", work: "Заместитель директора" },
        { name: "Левон Габриелян", work: "Директор по продажам" },
        { name: "Давид Товмасян", work: "Директор филиала Армавир" },
        { name: "Гаруш Степанян", work: "Директор филиала г. Арарат" },
        {
          name: "Седа Седракян",
          work: "Руководитель отдела финансирования продаж",
        },
        { name: "Асмик Гадян", work: "Руководитель договорного отдела" },
        { name: "Нинель Хачатурян", work: "Руководитель колл-центра" },
        { name: "София Фахрадян", work: "Бухгалтер" },
        { name: "Карен Казарян", work: "Энергетик" },
        { name: "Телман Ованнисян", work: "Заведующий складом" },
        { name: "Карен Егиазарян", work: "Начальник отдела контроля качества" },
        {
          name: "Арген Туманян",
          work: "Специалист отдела финансирования продаж",
        },
        { name: "Ованнес Геворгян", work: "Менеджер" },
        { name: "Тамара Овсепян", work: "Специалист колл-центра" },
      ],
      ongrid_title: "☀️ Ongrid (сетевые) солнечные системы",
      ongrid_description:
        "Ongrid системы подключены к электрической сети и работают совместно. Произведенная энергия сначала используется для ваших нужд, а излишки передаются в общую сеть.",
      ongrid_advantages: "Преимущества",
      ongrid_adv1: "Низкие инвестиции (аккумуляторы не требуются)",
      ongrid_adv2: "Высокая эффективность",
      ongrid_adv3: "Значительное снижение расходов на электроэнергию",
      ongrid_disadvantages: "Недостатки",
      ongrid_disadv1: "При отключении электроэнергии система не работает",
      ongrid_suitable: "Подходит для",
      ongrid_suitable_text:
        "Квартир, частных домов и бизнеса, где есть стабильная электросеть",
      ongrid_key_feature: "Экономьте без больших стартовых вложений",

      offgrid_title: "🔋 Offgrid (автономные) солнечные системы",
      offgrid_description:
        "Offgrid системы полностью независимы от электрической сети и работают с помощью аккумуляторов, накапливая солнечную энергию.",
      offgrid_advantages: "Преимущества",
      offgrid_adv1: "Полная энергетическая независимость",
      offgrid_adv2: "Работает даже при отсутствии электроэнергии",
      offgrid_disadvantages: "Недостатки",
      offgrid_disadv1: "Более высокая стоимость (из-за аккумуляторов)",
      offgrid_disadv2:
        "Необходимость периодического обслуживания аккумуляторов",
      offgrid_suitable: "Подходит для",
      offgrid_suitable_text:
        "Отдаленных территорий, дач и мест, где нет электрической сети",
      offgrid_key_feature: "Будьте полностью независимы от электросети",

      hybrid_title: "⚡ Hybrid (гибридные) солнечные системы",
      hybrid_description:
        "Hybrid системы объединяют ongrid и offgrid решения, работая как с сетью, так и с аккумуляторами.",
      hybrid_advantages: "Преимущества",
      hybrid_adv1: "Работает при отключении электроэнергии",
      hybrid_adv2: "Позволяет экономить и одновременно иметь резервную энергию",
      hybrid_adv3: "Гибкое и интеллектуальное управление",
      hybrid_disadvantages: "Недостатки",
      hybrid_disadv1: "Более высокая цена по сравнению с ongrid",
      hybrid_suitable: "Подходит для",
      hybrid_suitable_text:
        "Домов и бизнеса, которые хотят и экономить, и обеспечить бесперебойное питание",
      hybrid_key_feature: "Совмещайте экономию и бесперебойное питание",
      exhibition_title: "Международная выставка Кантон 2025",
      exhibition_text_1:
        "15 октября 2025 года компания Solar Holding в лице основателя Игоря Авакяна приняла участие в международной выставке Кантон в городе Гуанчжоу, Китай (China Import and Export Fair).",
      exhibition_text_2:
        "Участие позволило представить наши солнечные энергетические решения, изучить тенденции международного рынка и установить новые партнерские отношения, направленные на устойчивое энергетическое развитие и инновации.",
      exhibition_text_3:
        "В рамках выставки состоялся ряд важных встреч. В частности, переговоры с представителями Солис прошли в конструктивной атмосфере. Мы представили наши предложения и варианты углубления сотрудничества.",
      exhibition_text_4:
        "Был выделен ряд вопросов, представляющих общий интерес, которые мы рассмотрим более подробно в ближайшее время.",
      solar_systems_title: "Солнечные системы",
      solar_systems_subtitle: "Выберите подходящее для вас решение",
      branches_page_title: "Филиалы",
      branches_page_subtitle: "Выберите филиал и посмотрите полную информацию",
      branches_address_label: "Адрес",
      branches_open_map: "Открыть на карте",
      branches_select_prompt:
        "Нажмите на карточку филиала, чтобы увидеть подробности.",
      branches_list: [
        {
          name: "Главный офис",
          address: "г. Ереван, ул. Таирова, 46",
          mapUrl:
            "https://yandex.ru/navi/org/solar_holding/121702865151?si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Филиал г. Арарат",
          address: "г. Арарат, ул. Ахбюр Сероба, 12/1",
          mapUrl:
            "https://yandex.ru/navi/org/solar_holding/208880807718?si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Call Centre",
          address: "г. Арарат, ул. Абовяна, 11/50",
          mapUrl:
            "https://yandex.ru/navi?whatshere%5Bzoom%5D=20&whatshere%5Bpoint%5D=44.695868,39.857169&si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Филиал с. Арарат",
          address: "с. Арарат, ул. Грибоедова, 8",
          mapUrl:
            "https://yandex.ru/navi?whatshere%5Bzoom%5D=19&whatshere%5Bpoint%5D=44.705706,39.836641&si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Филиал Эчмиадзин",
          address: "г. Эчмиадзин, ул. Патканяна, 21/5",
          mapUrl: "https://yandex.ru/maps/-/CPvUrElm",
        },
        {
          name: "Филиал Армавир",
          address: "г. Армавир, Ереванян 15/4",
          mapUrl:
            "https://yandex.ru/navi?text=40.143922,44.038862&si=t40ungzmvnuzbwjxezh11d40hr",
        },
      ],
      no_project_selected: "Проект не выбран",
      back: "Назад",
      services_page_title: "Наши Услуги",
      services_page_subtitle: "SOLAR HOLDING",
      services_page_intro:
        "Solar Holding предлагает комплексные решения для солнечных систем: от импорта до установки и обслуживания.",
      services_advantages_title: "Почему выбирают нас",
      services_advantages_list: [
        "Высокое качество",
        "Быстрая установка",
        "Профессиональная команда",
        "Лучшие цены",
      ],
      services_cta_title: "Готовы перейти на солнечную энергию?",
      services_cta_button: "Связаться",
      services_page_items: [
        {
          title: "Продажа солнечных станций",
          desc: "Мы предлагаем высококачественные солнечные станции различной мощности для дома и бизнеса.",
        },
        {
          title: "Установка солнечных систем",
          desc: "Наши специалисты выполняют быструю и качественную установку, обеспечивая долгую работу системы.",
        },
        {
          title: "Импорт и поставка",
          desc: "Мы импортируем все необходимые компоненты солнечных систем, обеспечивая лучшее соотношение цены и качества.",
        },
        {
          title: "Перемещение станций",
          desc: "Выполняем профессиональное перемещение солнечных станций на любые расстояния с полной безопасностью оборудования и быстрой установкой на новом месте.",
        },
      ],
      contact_page_title: "Обратная связь",
      contact_page_subtitle: "Свяжитесь с нами",
      contact_name_placeholder: "Имя",
      contact_email_placeholder: "Эл. почта",
      contact_message_placeholder: "Сообщение",
      contact_send_button: "Отправить",
      contact_send_loading: "Отправка сообщения...",
      contact_send_error: "Ошибка отправки. Попробуйте позже.",
      contact_fill_all_fields: "Пожалуйста, заполните все поля.",
      contact_sent_alert: "Сообщение отправлено ✅",
      certificates_page_title: "Лицензии и сертификаты",
      certificates_page_subtitle: "официальные документы",
      jobs_page_title: "Вакансии",
      jobs_page_subtitle: "Присоединяйтесь к нашей команде",
      jobs_apply_deadline: "Срок подачи заявки:",
      jobs_apply_button: "Откликнуться",
      jobs_application_for: "Заявка на:",
      jobs_send_loading: "Отправка заявки...",
      jobs_send_error: "Ошибка отправки. Попробуйте позже.",
      jobs_fill_all_fields: "Пожалуйста, заполните все поля.",
      jobs_success_title: "Заявка отправлена ✅",
      jobs_success_subtitle: "Спасибо за интерес",
      jobs_name_placeholder: "Имя",
      jobs_email_placeholder: "Эл. почта",
      jobs_message_placeholder: "Сообщение / опыт",
      jobs_submit_button: "Отправить заявку",
      jobs_list: ["Специалист колл-центра", "Менеджер по продажам"],
      videos_page_title: "Видео",
      videos_page_subtitle: "Наши проекты в видеоформате",
      video_error_loading: "Ошибка загрузки видео",
      loading_player: "Загрузка плеера...",
    },
  },
  en: {
    translation: {
      all_works: "wiew all",
      home: "Home",
      about: "About Us",
      team: "Our Team",
      jobs: "Vacancies",
      certificates: "Awards & Certificates",
      videos: "Videos",
      services: "Services",
      portfolio: "Portfolio",
      branches: "Branches",
      contact: "Contact",
      herotext: "Discover new sun energy possibilities ",
      wellcometitle: "Your Solar Future",
      wellcometitle2: "Welcome to Solar Holding LLC",
      wellcomelist: [
        "Solar Holding is a solar energy organization engaged in the import, sale, and installation of solar stations and water heaters.",
        "The company began its active operations on March 17, 2020. The focus is on quality, as evidenced by our customers.",
        "The installed solar panels are manufactured by industry leaders Q-Sun and Longi, known for their high quality and efficiency. The systems are equipped with high-grade, reliable inverters from Solis and Deye.",
        "Solar Holding is the official representative of Q-Sun solar panels in the Caucasus region.",
        "From December 1 to January 30, customers who purchased solar stations participated in the BYD E2 electric car raffle. The winner was Gohar Isajanyan from the city of Ararat.",
      ],
      wellcomrbtn: "More information",
      Dissatisfiedcustomers: "Dissatisfied customers",
      Employees: "Employees",
      Satisfiedcustomers: "Satisfied customers",
      Services: "Services",
      Trialoftheyear: "Years of Trial",
      Whysolarenergy: "Why\n solar energy ?",
      click_on_service: "Tap any card for details",
      click_on_card: "Tap any card above for details",
      whyinfo: `
      Solar energy is the largest and most abundant energy source in the world. 
      Solar energy can be converted into both electrical and thermal energy. 
      The efficiency of converting solar energy into thermal energy is about 70%, 
      and into electrical energy is about 22%. The use of solar energy has a number of 
      advantages that make the sector particularly attractive from both an investment and social perspective. 
      Thus, for every type of consumer, switching to solar energy can be the best option for saving and sustainable development.`,
      whylist: [
        "An unlimited, renewable, and clean source of energy",
        "Independence from rising gas and electricity prices in the long term",
        "Significant environmental benefits, including reduction of CO2 emissions, use of desertified lands, and combating global warming",
        "A stable investment opportunity with minimal risks and maximum long-term savings",
        "Social benefits, including improved living conditions through solving household problems and generating savings",
      ],
      Thesun: "The sun, your energy source",
      convert: "Convert sunlight into powerful and sustainable energy.",
      Whychoose: "Why choose us?",
      Weoffer: "We offer the best solar solutions.",
      service1title: "Free measurement",
      service1desc:
        "We provide free measurements to ensure accurate and efficient installation of the solar system.",
      service2title: "Free consultation",
      service2desc:
        "Our specialists will help you choose the best solution based on your needs and budget.",
      service3title: "Free installation",
      service3desc:
        "We ensure fast and high-quality installation with guaranteed long-term performance.",
      options_data: [
        {
          title: "High Quality",
          desc: "We use only high-quality materials, ensuring long-term and reliable results.",
        },
        {
          title: "Individual Approach",
          desc: "Each project is developed taking into account your requirements and budget.",
        },
        {
          title: "Tight Deadlines",
          desc: "Work is carried out quickly and within clear deadlines without loss of quality.",
        },
        {
          title: "Professional Team",
          desc: "Our experienced specialists provide high-class service at every stage.",
        },
        {
          title: "Years of Experience",
          desc: "Years of experience allow us to offer reliable and efficient solutions.",
        },
        {
          title: "Affordable Prices",
          desc: "We offer competitive prices with the best value/quality ratio.",
        },
        {
          title: "Premium Materials",
          desc: "We use only tested and certified materials.",
        },
        {
          title: "Technical Support",
          desc: "We provide ongoing technical maintenance and support.",
        },
      ],
      works_title: "Our Works",
      works_subtitle: "Choose your project",
      complexes_data: [
        {
          number: 1,
          name: "Installed Capacity 198.4 kW",
          info: `A-TEG LLC, Dilijan, Tbilisi Highway 17. Installed 275 Q-SUN 720W panels, annual output 277,760 kWh, annual savings 13,888,000 AMD. Installed SOLIS inverters with 80 and 100 kW capacity.`,
        },
        {
          number: 2,
          name: "Installed Capacity 49.99 kW",
          info: `Artur Kirakosyan, Hovtashat 12th St / 53. Installed 78 SAIL SOLAR 648W panels, annual output 69,888 kWh, annual savings 3,494,400 AMD. Installed SOLIS inverter with 50 kW capacity.`,
        },
        {
          number: 3,
          name: "Installed Capacity 149.76 kW",
          info: `Bakhtiko LLC, Hovtashat, Baghramyan St 3 / 81. Installed 234 LONGI 648W panels, annual output 209,664 kWh, annual savings 10,483,200 AMD. Installed SOLIS inverters with 50 and 100 kW capacity.`,
        },
        {
          number: 4,
          name: "Installed Capacity 34.16 kW",
          info: `Hakob Safaryan, Yerevan, Tigran Mets Ave 40 / 4. Installed 56 SAIL SOLAR 610W panels, annual output 47,824 kWh, annual savings 2,391,200 AMD. Installed SOLIS inverter with 30 kW capacity.`,
        },
        {
          number: 5,
          name: "Installed Capacity 50.22 kW",
          info: `Tavush Region, Ijevan, H. Mehrabyan St 102 / 5. Installed 81 Q-SUN 620W panels, annual output 60,264 kWh, annual savings 3,013,200 AMD. Installed SOLIS inverter with 100 kW capacity.`,
        },
        {
          number: 6,
          name: "JIADELE Water Heater",
          info: `Hrazdan 6 / 1, 1st St. Installed JIADELE water heaters, 8 units with 400L capacity each.`,
        },
        {
          number: 7,
          name: "Installed Capacity 130.2 kW",
          info: `Alex 99 LLC, Marmarashen, Yerevan-Artashat Highway 4 / 1. Installed 210 Q-SUN 620W panels, annual output 195,300 kWh, annual savings 9,765,000 AMD. Installed SOLIS inverters with 100 and 30 kW capacity.`,
        },
        {
          number: 8,
          name: "JIADELE Water Heater",
          info: `S Ve Hotel LLC, Davtashen, Yeghvard Highway 126. JIADELE water heaters, 10 units with 400L capacity.`,
        },
        {
          number: 9,
          name: "Installed Capacity 65.1 kW",
          info: `VV Gaz LLC, Dilijan, Tbilisi Highway 14. Installed 105 Q-SUN 620W panels, annual output 768,120 kWh, annual savings 3,906,000 AMD. Installed SOLIS inverter with 60 kW capacity.`,
        },
        {
          number: 10,
          name: "Installed Capacity 29.76 kW",
          info: `Hayk Khachatryan, Darakert, Haidukneri St 22 / 1. Installed 48 Q-SUN 620W panels, annual output 744,640 kWh, annual savings 2,232,000 AMD. Installed SOLIS inverter with 30 kW capacity.`,
        },
        {
          number: 11,
          name: "Installed Capacity 34.72 kW",
          info: `Andranik Simonyan, Ararat Region, Shahumyan village, Sargsyan St 21. Installed 56 Q-SUN 620W panels, annual output 52,080 kWh, annual savings 2,604,000 AMD. Installed SOLIS inverter with 30 kW capacity.`,
        },
        {
          number: 12,
          name: "Installed Capacity 35.96 kW",
          info: `PE Kolya Hovhannisyan Mihrani, Armavir, Alashkert 27 St / 5. Installed 58 Q-SUN 620W panels, annual output 53,940 kWh, annual savings 2,697,000 AMD. Installed SOLIS inverter with 30 kW capacity.`,
        },
        {
          number: 13,
          name: "Installed Capacity 29.76 kW",
          info: `Armavir, Mrgashat village, 2nd St, 1st bldg. Installed 48 Q-SUN 620W panels, annual output 44,620 kWh, annual savings 2,232,000 AMD. Installed SOLIS inverter with 40 kW capacity.`,
        },
        {
          number: 14,
          name: "Installed Capacity 29.76 kW",
          info: `Sargis Sahakyan, Echmiadzin, Voskehat Highway. Installed 65 Q-SUN 620W panels, annual output 60,450 kWh, annual savings 3,022,500 AMD. Installed SOLIS inverter with 40 kW capacity.`,
        },
        {
          number: 15,
          name: "Installed Capacity 53.32 kW",
          info: `Makrutyun LLC, Yerevan, Shengavit, Artashat Highway 1 / 22. Installed 86 Q-SUN 620W panels, annual output 79,980 kWh, annual savings 3,999,000 AMD. Installed SOLIS inverter with 50 kW capacity.`,
        },
        {
          number: 16,
          name: "Installed Capacity 161.92 kW",
          info: `Etalon Supermarket, Yerevan, Malatia-Sebastia, Bashinjaghyan 175/7. Installed 253 LONGI 640W panels, annual output 210,496 kWh, annual savings 12,144,000 AMD. Installed SOLIS inverters with 100 and 50 kW capacity.`,
        },
        {
          number: 17,
          name: "Installed Capacity 34.72 kW",
          info: `Hamlet Palanduzyan, Tavush, Mashtots 1358. Installed 56 Q-SUN 640W panels, annual output 41,664 kWh, annual savings 2,083,200 AMD. Installed SOLIS inverter with 30 kW capacity.`,
        },
        {
          number: 18,
          name: "Installed Capacity 90 kW",
          info: `R and Sreg LLC, Goris, Arakelyan St 30. Installed 129 Q-SUN 620W panels, annual output 103,974 kWh, annual savings 5,198,700 AMD. Installed Foxess inverter with 75 kW capacity.`,
        },
        {
          number: 19,
          name: "Installed Capacity 70.4 kW",
          info: `GorHak Trade, Yerevan, Shiraki St 90 / 1. Installed 129 Q-SUN 620W panels, annual output 105,600 kWh, annual savings 5,250,000 AMD. Installed SOLIS inverters with 50 and 20 kW capacity.`,
        },
        {
          number: 20,
          name: "Installed Capacity 60.27 kW",
          info: `Mig Techspasarkum LLC, Kotayk Region, Balahovit village, 8th St, 15th bldg. Installed 98 LONGI 615W panels, annual output 90,405 kWh, annual savings 4,520,250 AMD. Installed SOLIS inverters with 60 and 20 kW capacity.`,
        },
        {
          number: 21,
          name: "Installed Capacity 90.82 kW",
          info: `Mayis Mkrtchyan, Vayots Dzor Region, Arpa Parnas Complex, Noravank. Installed 161 Q-SUN 620W panels, annual output 149,730 kWh, annual savings 7,486,500 AMD. Installed Foxess inverters with 60 and 40 kW capacity.`,
        },
        {
          number: 22,
          name: "Installed Capacity 9.92 kW",
          info: `Surb Trdat Church, Vayk, Vayots Dzor Region. Installed 16 Q-SUN 620W panels, annual output 15,000 kWh, annual savings 750,000 AMD. Installed SOLIS inverter with 10 kW capacity.`,
        },
        {
          number: 23,
          name: "Installed Capacity 70.06 kW",
          info: `Voske Hask LLC, Artashat, Yerevan-Yeraskh Highway 28km. Installed 113 Q-SUN 620W panels, annual output 105,090 kWh, annual savings 5,254,500 AMD. Installed Foxess inverter with 75 kW capacity.`,
        },
        {
          number: 24,
          name: "Installed Capacity 49.6 kW",
          info: `ML Hotel, Agarak, Syunik Region. Installed 80 Q-SUN 620W panels, annual output 55,000 kWh, annual savings 2,750,000 AMD. Installed SOLIS inverters with 15 and 30 kW capacity.`,
        },
        {
          number: 25,
          name: "Installed Capacity 70.11 kW",
          info: `Yerevan, Kanaker-Zeytun, Aharonyan 12. Installed 114 LONGI 620W panels, annual output 105,165 kWh, annual savings 5,258,250 AMD. Installed Foxess inverter with 75 kW capacity.`,
        },
        {
          number: 26,
          name: "Installed Capacity 79.98 kW",
          info: `GAV LLC, Ararat Region, Avshar village. Installed 129 LONGI 620W panels, annual output 119,970 kWh, annual savings 5,998,500 AMD. Installed Fox inverter with 75 kW capacity.`,
        },
        {
          number: 27,
          name: "Installed Capacity 150.04 kW",
          info: `Bozoyan LLC, Lori Region, Metsavan village. Installed 242 LONGI 620W panels, annual output 195,052 kWh, annual savings 9,752,600 AMD. Installed Huawei inverters with 50 and 100 kW capacity.`,
        },
        {
          number: 28,
          name: "Installed Capacity 29.70 (30) kW",
          info: `Ararat city, Griboyedov St 29 / 1. Installed 48 Q-SUN 620W panels, annual output 44,640 kWh, annual savings 2,232,000 AMD. Installed SOLIS inverter with 30 kW capacity.`,
        },
        {
          number: 29,
          name: "Installed Capacity 150.06 kW",
          info: `Armavir Region, Eghegnut village. Installed 243 LONGI 615W panels, annual output 225,090 kWh, annual savings 11,254,500 AMD. Installed Huawei inverters with 50 and 100 kW capacity.`,
        },
        {
          number: 30,
          name: "Installed Capacity 171 kW",
          info: `GAV BAZ LLC. Installed 300 LONGI 550W panels, annual output 274,000 kWh, annual savings 14,552,000 AMD. Installed Huawei inverters with 100 and 60 kW capacity.`,
        },
        {
          number: 31,
          name: "Installed Capacity 125 kW",
          info: `Vahagni Wedding Hall. Installed 227 JINKO 550W panels, annual output 187,500 kWh. Installed Huawei inverters with 30 and 100 kW capacity.`,
        },
        {
          number: 32,
          name: "Installed Capacity 79.8 kW",
          info: `PE Armen Manukyan, Aralez village, stone processing workshop. Installed 109 LONGI 555W panels, annual output 90,000 kWh, annual savings 14,522,000 AMD. Installed SUNWAYS inverters: 3 units of 20 kW.`,
        },
        {
          number: 33,
          name: "Installed Capacity 79.8 kW",
          info: `GAV BAZ LLC. Installed LONGI 52.8 kW and Risen 27 kW, annual output 119,700 kWh, annual savings 5,985,000 AMD. Installed FOX inverters: 3 units of 25 kW.`,
        },
      ],
      partners_title: "Our Partners",
      footer_contacts: "Our Contacts",
      footer_address: "46 Tairov St, Yerevan, Armenia",
      footer_map: "Site Map",
      footer_rights: "All rights reserved",
      footer_team: "Our Staff",
      footer_jobs: "Jobs",
      footer_certs: "Awards & Certificates",
      footer_videos: "Videos",
      team_title: "Our Team",
      team_subtitle: "meet our professionals",
      team_members: [
        { name: "Igor Avakyan", work: "Founder" },
        { name: "Gevorg Arshakyan", work: "CEO" },
        { name: "Suren Avagyan", work: "CTO" },
        { name: "Narek Hovhannisyan", work: "Deputy Director" },
        { name: "Levon Gabrielyan", work: "Sales Director" },
        { name: "David Tovmasyan", work: "Armavir Branch Director" },
        { name: "Garush Stepanyan", work: "Ararat Branch Director" },
        { name: "Seda Sedrakyan", work: "Head of Sales Financing Department" },
        { name: "Hasmik Ghadyan", work: "Head of Contract Department" },
        { name: "Ninel Khachatryan", work: "Call Center Manager" },
        { name: "Sofia Fahradyan", work: "Accountant" },
        { name: "Karen Ghazaryan", work: "Energy Specialist" },
        { name: "Telman Hovhannisyan", work: "Warehouse Manager" },
        {
          name: "Karen Yeghiazaryan",
          work: "Head of Quality Control Department",
        },
        { name: "Argen Tumanyan", work: "Sales Financing Specialist" },
        { name: "Hovhannes Gevorgyan", work: "Manager" },
        { name: "Tamara Hovsepyan", work: "Call Center Specialist" },
      ],
      ongrid_title: "☀️ Ongrid (Grid-Tied) Solar Systems",
      ongrid_description:
        "Ongrid systems are connected to the electrical grid and work together. The generated energy is first used for your needs, and the excess is transferred to the common grid.",
      ongrid_advantages: "Advantages",
      ongrid_adv1: "Low investment (batteries not required)",
      ongrid_adv2: "High efficiency",
      ongrid_adv3: "Significant reduction in electricity costs",
      ongrid_disadvantages: "Disadvantages",
      ongrid_disadv1: "System does not work during power outage",
      ongrid_suitable: "Suitable for",
      ongrid_suitable_text:
        "Apartments, private houses and businesses where there is a stable electrical grid",
      ongrid_key_feature: "Save without large upfront investments",

      offgrid_title: "🔋 Offgrid (Off-Grid) Solar Systems",
      offgrid_description:
        "Offgrid systems are completely independent from the electrical grid and work using batteries, storing solar energy.",
      offgrid_advantages: "Advantages",
      offgrid_adv1: "Complete energy independence",
      offgrid_adv2: "Works even during power outages",
      offgrid_disadvantages: "Disadvantages",
      offgrid_disadv1: "Higher cost (due to batteries)",
      offgrid_disadv2: "Need for periodic battery maintenance",
      offgrid_suitable: "Suitable for",
      offgrid_suitable_text:
        "Remote areas, summer houses and places where there is no electrical grid",
      offgrid_key_feature: "Stay fully independent from the grid",

      hybrid_title: "⚡ Hybrid Solar Systems",
      hybrid_description:
        "Hybrid systems combine ongrid and offgrid solutions, working with both the grid and batteries.",
      hybrid_advantages: "Advantages",
      hybrid_adv1: "Works during power outages",
      hybrid_adv2: "Allows saving while having backup energy",
      hybrid_adv3: "Flexible and smart management",
      hybrid_disadvantages: "Disadvantages",
      hybrid_disadv1: "Higher price compared to ongrid",
      hybrid_suitable: "Suitable for",
      hybrid_suitable_text:
        "Homes and businesses that want both savings and uninterrupted power supply",
      hybrid_key_feature: "Combine savings with uninterrupted power",
      exhibition_title: "International Canton Fair 2025",
      exhibition_text_1:
        "On October 15, 2025, Solar Holding, represented by founder Igor Avakyan, participated in the international Canton Fair in Guangzhou, China (China Import and Export Fair).",
      exhibition_text_2:
        "The participation allowed us to present our solar energy solutions, study international market trends, and establish new partnerships aimed at sustainable energy development and innovation.",
      exhibition_text_3:
        "A number of important meetings took place during the exhibition. In particular, negotiations with Solis representatives were held in a constructive atmosphere. We presented our proposals and options for deepening cooperation.",
      exhibition_text_4:
        "Several issues of common interest were identified, which we will address in more detail in the near future.",
      solar_systems_title: "Solar Systems",
      solar_systems_subtitle: "Choose the solution that suits you",
      branches_page_title: "Branches",
      branches_page_subtitle: "Select a branch to view full details",
      branches_address_label: "Address",
      branches_open_map: "Open on map",
      branches_select_prompt: "Click any branch card to view details.",
      branches_list: [
        {
          name: "Head Office",
          address: "46 Tairov Street, Yerevan",
          mapUrl:
            "https://yandex.ru/navi/org/solar_holding/121702865151?si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Ararat City Branch",
          address: "12/1 Akhbyur Serob Street, Ararat",
          mapUrl:
            "https://yandex.ru/navi/org/solar_holding/208880807718?si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Call Centre",
          address: "11/50 Abovyan Street, Ararat",
          mapUrl:
            "https://yandex.ru/navi?whatshere%5Bzoom%5D=20&whatshere%5Bpoint%5D=44.695868,39.857169&si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Ararat Village Branch",
          address: "8 Griboyedov Street, Ararat Village",
          mapUrl:
            "https://yandex.ru/navi?whatshere%5Bzoom%5D=19&whatshere%5Bpoint%5D=44.705706,39.836641&si=t40ungzmvnuzbwjxezh11d40hr",
        },
        {
          name: "Ejmiatsin Branch",
          address: "21/5 Patkanyan Street, Ejmiatsin",
          mapUrl: "https://yandex.ru/maps/-/CPvUrElm",
        },
        {
          name: "Armavir Branch",
          address: "15/4 Yerevanyan Street, Armavir",
          mapUrl:
            "https://yandex.ru/navi?text=40.143922,44.038862&si=t40ungzmvnuzbwjxezh11d40hr",
        },
      ],
      no_project_selected: "No project selected",
      back: "Back",
      services_page_title: "Our Services",
      services_page_subtitle: "SOLAR HOLDING",
      services_page_intro:
        "Solar Holding offers end-to-end solar solutions, from import and supply to installation and maintenance.",
      services_advantages_title: "Why Choose Us",
      services_advantages_list: [
        "High Quality",
        "Fast Installation",
        "Professional Team",
        "Best Prices",
      ],
      services_cta_title: "Ready to switch to solar energy?",
      services_cta_button: "Contact Us",
      services_page_items: [
        {
          title: "Solar Station Sales",
          desc: "We offer high-quality solar stations with different capacities for your home or business.",
        },
        {
          title: "Solar System Installation",
          desc: "Our specialists provide fast and high-quality installation to ensure long-term system performance.",
        },
        {
          title: "Import and Supply",
          desc: "We import all required components for solar systems, ensuring the best price-to-quality ratio.",
        },
        {
          title: "Station Relocation",
          desc: "We professionally relocate solar stations over any distance, ensuring equipment safety and quick reinstallation at the new location.",
        },
      ],
      contact_page_title: "Contact Us",
      contact_page_subtitle: "Get in touch with us",
      contact_name_placeholder: "Name",
      contact_email_placeholder: "Email",
      contact_message_placeholder: "Message",
      contact_send_button: "Send",
      contact_send_loading: "Sending message...",
      contact_send_error: "Send error. Please try again later.",
      contact_fill_all_fields: "Please fill all fields.",
      contact_sent_alert: "Message sent ✅",
      certificates_page_title: "Licenses and Certificates",
      certificates_page_subtitle: "official documents",
      jobs_page_title: "Vacancies",
      jobs_page_subtitle: "Join our team",
      jobs_apply_deadline: "Application deadline:",
      jobs_apply_button: "Apply",
      jobs_application_for: "Application for:",
      jobs_send_loading: "Sending application...",
      jobs_send_error: "Send error. Please try again later.",
      jobs_fill_all_fields: "Please fill all fields.",
      jobs_success_title: "Application sent ✅",
      jobs_success_subtitle: "Thank you for your interest",
      jobs_name_placeholder: "Name",
      jobs_email_placeholder: "Email",
      jobs_message_placeholder: "Message / experience",
      jobs_submit_button: "Submit application",
      jobs_list: ["Call Center Specialist", "Sales Manager"],
      videos_page_title: "Videos",
      videos_page_subtitle: "Our projects in video format",
      video_error_loading: "Error loading video",
      loading_player: "Loading player...",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "am",
    fallbackLng: "am",
    detection: {
      // Пытаемся найти язык в хранилище, если нет — используем fallbackLng ("am")
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
      ],
      caches: ["localStorage", "cookie"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
